import React from 'react';

/**
 * Εμφανίζει μεταφρασμένο κείμενο που περιέχει tokens της μορφής {name}
 * και τα αντικαθιστά με React nodes (π.χ. συνδέσμους).
 *
 * Γιατί έτσι και όχι με σπάσιμο σε πολλά κλειδιά ή με dangerouslySetInnerHTML:
 *  - Το i18n μένει ΕΝΑ κλειδί ανά γλώσσα, άρα κάθε γλώσσα βάζει το token
 *    όπου το θέλει η δική της σύνταξη (η σειρά των λέξεων διαφέρει).
 *  - Δεν μπαίνει HTML μέσα στα μεταφραστικά κλειδιά, άρα καμία επιφάνεια XSS.
 *
 * Άγνωστο ή μη δηλωμένο token εμφανίζεται ως έχει, χωρίς να σπάσει η σελίδα.
 */
const TOKEN = /(\{[a-zA-Z0-9_]+\})/g;

const RichText = ({ text, tokens = {} }) => (
  <>
    {String(text ?? '')
      .split(TOKEN)
      .map((part, i) => {
        const match = part.match(/^\{([a-zA-Z0-9_]+)\}$/);
        const value = match ? tokens[match[1]] : undefined;
        return (
          <React.Fragment key={i}>
            {value !== undefined ? value : part}
          </React.Fragment>
        );
      })}
  </>
);

export default RichText;
